import store from '@/store'
import { computed, onMounted, onUnmounted } from '@vue/composition-api'


const useOpsTeamStreams = (teamId: string) => {

  onMounted(async () => await store.dispatch.opsmonitor.subscribeStreams(teamId))
  onUnmounted(async () => await store.dispatch.opsmonitor.unsubscribeStreams(teamId))

  return {
    opsStreams: computed(() => store.state.opsmonitor.streams)
  }
}

export default useOpsTeamStreams
